import {AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {IAppState} from "../../../shared/redux-store/store";
import {Subject} from "rxjs/Subject";
import {TouchScanWizardService} from "./touch-scan-wizard/touch-scan-wizard.service";
import {MovingDirection, WizardComponent} from "ng2-archwizard/dist";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {Router} from "@angular/router";
import {SessionActions} from "../../../shared/actions";
import {MessageType} from "../../../shared/redux-store/session";
import {WithdrawalConsumerInterface} from "../../../store-management/model/withdrawal-consumer-interface.type";

export function selectActiveWithdrawal(state: IAppState) {
  let wd = state.withdrawals.withdrawalList.find(wd => wd.cuid === state.withdrawals.activeWithdrawalCuid);

  if (wd) {
    return wd;
  } else {
    return null;
  }

}

@Component({
  selector: 'vb-touch-scan',
  templateUrl: './touch-scan.component.html',
  providers: [TouchScanWizardService],
  styleUrls: ['./touch-scan.component.css']
})
export class TouchScanComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit, OnDestroy {

  MovingDirection;

  @ViewChild(WizardComponent)
  wizard: WizardComponent;

  currentStep: number;

  canExitDataPageProxy = (direction: MovingDirection) => this.canExitDataPage.apply(this, [direction]);
  canExitArticlePageProxy = (direction: MovingDirection) => this.canExitArticlePage.apply(this, [direction]);

  private isSaved: boolean = false;

  userEvent: Subject<any> = new Subject();

  @HostListener('document:keydown')
  handleUserKeyboardEvent() {
    this.userEvent.next();
  }

  @HostListener('document:click')
  handleUserClickEvent() {
    this.userEvent.next();
  }

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, public scanWizardService: TouchScanWizardService) {
    super(sessionActions, cd);

    this.MovingDirection = MovingDirection;

  }

  ngOnInit() {
    super.ngOnInit();
    this.scanWizardService.createNewWithdrawal();
  }

  ngAfterViewInit(): void {
    this.userEvent.next();
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    if (this.scanWizardService.withdrawnStocks.length == 0) {
      this.sessionActions.pushMessage("Warenentnahme wurde abgebrochen und nicht gespeichert!", MessageType.WARNING, "Warenentnahme");
      this.scanWizardService.cancelWithdrawal();
    } else {
      if (this.isSaved === false) {
        this.scanWizardService.saveWithdrawal().subscribe();
      }
    }

    this.scanWizardService.deselectActiveWithdrawal();

  }

  onStepChanged() {
    let step = this.wizard.model.getIndexOfStep(this.wizard.model.currentStep);
    this.currentStep = step;
  }

  onFinalStepEntered() {
    this.onStepChanged();
    this.saveWithdrawal();
  }

  onExitDataPage(direction: MovingDirection) {
    this.scanWizardService.saveWithdrawalReason();
  }

  onTimeout() {
    this.onGoHomeClicked();
  }

  onGoHomeClicked() {
    return this.router.navigate(['/touch']);
  }

  onConsumerSelected(consumer: WithdrawalConsumerInterface) {
    this.wizard.navigation.goToNextStep();
  }

  onArticleScanFinished() {
    this.wizard.navigation.goToNextStep();
  }

  canExitDataPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      return this.scanWizardService.canExitDataPage();
    }

    return false;

  }

  canExitArticlePage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      return this.scanWizardService.canExitArticlePage();
    } else {
      return true;
    }

  }

  saveWithdrawal() {
    this.isSaved = true;
    this.addSubscription(this.scanWizardService.saveWithdrawal().subscribe(
      res => {
        if (!this.scanWizardService.hasErrored()) {
          // this.onGoHomeClicked().then(() => location.reload())
          this.onGoHomeClicked();
        } else {
          this.onGoHomeClicked();
        }
      },
      err => this.onGoHomeClicked()
    ));
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-scan/touch-scan.component.ts